import React from 'react';
import styled from 'styled-components';

const ReviewsSection = styled.section`
  padding: 10rem 0;
  background: #f9fafb;

  @media (max-width: 768px) {
    padding: 5rem 0;
  }
`;

const RatingBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 2rem;
`;

const StarIcon = styled.span`
  color: #253ec6;
  font-size: 1.2rem;
`;

const RatingText = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: #000;
`;

const SectionTitle = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 2.5rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 3rem;
  color: #000;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const TestimonialsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const TestimonialCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: relative;
`;

const QuoteIcon = styled.div`
  font-size: 3rem;
  color: #253ec6;
  font-weight: bold;
  margin-bottom: 1rem;
  line-height: 1;
`;

const TestimonialText = styled.p`
  font-style: italic;
  color: #000;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-size: 1rem;
`;

const TestimonialAuthor = styled.div`
  color: #000;
  font-weight: 400;
  font-size: 0.95rem;
`;

const testimonials = [
  {
    text: 'Set it and forget it. My cleaner knows the routine, and access is always smooth.',
    author: '— Jordan L.',
  },
  {
    text: "I'm not home most days. They coordinate with the building and it just gets done.",
    author: '— Alex W.',
  },
  {
    text: 'I use tasks for small stuff between deep cleans. Sheets, dishes, quick organize.',
    author: '— Morgan J.',
  },
];

export default function Reviews() {
  return (
    <ReviewsSection id="testimonials">
      <div className="container">
        <RatingBadge>
          <StarIcon>★</StarIcon>
          <RatingText>4.9/5</RatingText>
        </RatingBadge>

        <SectionTitle>Resident testimonials</SectionTitle>

        <TestimonialsContainer>
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index}>
              <QuoteIcon>"</QuoteIcon>
              <TestimonialText>{testimonial.text}</TestimonialText>
              <TestimonialAuthor>{testimonial.author}</TestimonialAuthor>
            </TestimonialCard>
          ))}
        </TestimonialsContainer>
      </div>
    </ReviewsSection>
  );
}
